var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBackgroundLines1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 264,
    viewBox: "0 0 88 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.688 160.856L39.0166 138.395L88.8596 280.248",
    stroke: "url(#paint0_linear_1238_92480)",
    strokeWidth: 0.414996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.141 -21.7109L122.058 -32.9939L149.414 44.8595C151.693 51.3466 148.089 55.4465 141.363 54.0169L59.4767 36.6114C52.7813 35.1883 49.1736 39.2454 51.4 45.694L113.136 224.511",
    stroke: "url(#paint1_linear_1238_92480)",
    strokeWidth: 0.414996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.692 228.397L20.1401 202.989C13.258 201.393 9.5046 205.503 11.825 212.095L81.8484 411.011",
    stroke: "url(#paint2_linear_1238_92480)",
    strokeWidth: 0.414996
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1238_92480",
    x1: 98.1311,
    y1: 342.433,
    x2: 274.586,
    y2: 93.0204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900457,
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1238_92480",
    x1: 65.1167,
    y1: 14.1764,
    x2: 36.1047,
    y2: 221.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1238_92480",
    x1: -19.7067,
    y1: 168.43,
    x2: 50.944,
    y2: 313.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBackgroundLines1);
export default __webpack_public_path__ + "static/media/right-backgroundLines1.2fdca1a4cd5db672cf0f3af77121f884.svg";
export { ForwardRef as ReactComponent };